import React from "react";
import { Typewriter } from 'react-simple-typewriter'
const Frontcontent = () => { 
  return (
    <section className="hero-section page-section scroll-to-page" id="home">
      <div className="custom-container">
        <div className="hero-content content-width">
          <div className="section-header">
            <h4
              className="subtitle scroll-animation"
              data-animation="fade_from_bottom"
            >
              <i className="las la-home" /> Introduce

            </h4>
            <h1
              className="scroll-animation"
              style={{ fontWeight: 600,fontSize:'50px',margin:"0px" }}
              data-animation="fade_from_bottom"
            >
             I'm a <span style={{fontWeight:'bold',color:'green'}}>
                
              <Typewriter
            words={['React Developer', 'PHP Developer', 'Node Developer', 'Database Developer']}
            loop={true}
            cursor
            cursorStyle='|'
            cursorColor="white"
            cu
            typeSpeed={50}
            deleteSpeed={50}
            delaySpeed={1000}
          /></span>
            </h1>
          </div>
          <p className="scroll-animation" data-animation="fade_from_bottom">
            As a fullstack developer, I have the ability to bring a project to
            life from concept to deployment.
          </p>
          
          <div className="facts d-flex">
            <div
              className="left scroll-animation"
              data-animation="fade_from_left"
            >
              <h1>1+</h1>
              <p>
                Years of <br />
                Experience
              </p>
            </div>
            <div
              className="right scroll-animation"
              data-animation="fade_from_right"
            >
              <h1>3+</h1>
              <p>
                Live Projects <br />
              </p>
            </div>
            <div
              className="right scroll-animation"
              data-animation="fade_from_right"
            >
              <h1>12+</h1>
              <p>
                Worked on <br />
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Frontcontent;
